import React, { useEffect, useState } from 'react';

// Barra de progresso vertical (lado esquerdo) com degradê laranja.
// Atualiza dinamicamente conforme o usuário rola a página.
const ScrollProgressBar = () => {
  const [progress, setProgress] = useState(0);

  useEffect(() => {
    const onScroll = () => {
      const scrollTop = window.scrollY;
      const docHeight = document.documentElement.scrollHeight - window.innerHeight;
      const pct = docHeight > 0 ? (scrollTop / docHeight) * 100 : 0;
      setProgress(Math.min(100, Math.max(0, pct)));
    };
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);
    return () => {
      window.removeEventListener('scroll', onScroll);
      window.removeEventListener('resize', onScroll);
    };
  }, []);

  return (
    <div
      data-testid="scroll-progress-bar"
      className="fixed left-0 top-0 h-screen w-1.5 z-[60] bg-orange-100/40 pointer-events-none"
    >
      <div
        className="w-full transition-[height] duration-150 ease-out"
        style={{
          height: `${progress}%`,
          background: 'linear-gradient(to bottom, #FBBF24, #F97316, #EA580C)',
          boxShadow: '0 0 10px rgba(249,115,22,0.5)',
        }}
      />
    </div>
  );
};

export default ScrollProgressBar;
